import { TEAM_CHAT_FALLBACK_MEMBER_NAME } from '../TeamChat.constants';
import {
  getMemberNickname,
  getMessageSender,
  scrollToTeamChatMessage,
  truncateMessagePreview,
} from '../TeamChat.utils';

import { PINNED_PREVIEW_MAX_CHARS } from './TeamChatPinnedStrip.constants';

export const buildPinnedPreview = text => truncateMessagePreview(text, PINNED_PREVIEW_MAX_CHARS);

export const onJumpToPinnedMessage = scrollToTeamChatMessage;

export const getPinnedSenderLabel = (message, members) => {
  const sender = getMessageSender(message, members);

  if (!sender) {
    return TEAM_CHAT_FALLBACK_MEMBER_NAME;
  }

  return getMemberNickname(sender) || sender.nickname || TEAM_CHAT_FALLBACK_MEMBER_NAME;
};
